const { default: Decimal } = require('decimal.js');
const ALLOWED_ROUNDS = [null, undefined, 0.05, 0.1, 1];

const rounding = (price, roundAmount) => {
	if (!ALLOWED_ROUNDS.includes(roundAmount)) throw Error('unsupported round amount');

	if (!roundAmount) return price;

	let priceDecimal = new Decimal(price).times(100);
	let roundDecimal = new Decimal(roundAmount).times(100);
	while (!priceDecimal.mod(roundDecimal).isZero()) {
		priceDecimal = priceDecimal.plus(1);
	}
	return priceDecimal.div(100).toNumber();
};

module.exports = { rounding };
